import React from "react";
import "../css/featured.css";
import Navbar from "../Navbar";
import ExploreMore from "../ExploreMore";

export const Women2 = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            The Artist Turned HR Leader: Esi Mmirba Wilson's Blueprint for HR
            Excellence
          </h1>
          <div className="article-category">
            Africa's 10 Most Influential Women Leaders to Watch in 2024
          </div>
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/Meghan-Duffy.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            <div className="article-image-caption">
              Esi Mmirba Wilson | Director, People and Transformation |
              Consolidated Bank Ghana
            </div>
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Meghan Duffy has dedicated the past fifteen years to mastering
              creative production, weaving compelling narratives that captivate
              audiences. Storytelling is intrinsic to her identity, and she
              revels in transforming ideas into visual experiences. Her
              extensive career includes both on-camera roles and
              behind-the-scenes production across a diverse range of shows.
              After studying at the University of Winnipeg, Meghan was admitted
              to the prestigious Creative Communications program, which
              specializes in broadcast production and journalism. Her journey
              has taken her through vibrant production hubs in Vancouver,
              Toronto, and Los Angeles before bringing her back to her roots in
              Manitoba. Post-graduation, Meghan immersed herself in both on-air
              and production roles, contributing to some of Canada’s most
              renowned programs, including Entertainment Tonight Canada,
              Dragon’s Den, CTV Morning Live, Winnipeg Direct, and Breakfast
              Television. As a journalist, Meghan is passionate about creating
              true crime concepts and innovatively bringing unscripted stories
              to life. She is also committed to expanding her scripted slate,
              working alongside her talented team to introduce bold ideas to the
              market, leveraging what Manitoba has to offer. I knew I wanted to
              be an entrepreneur when… I realized my desire to create a thriving
              career while raising my children in the place I love. Recognizing
              that the level of production I aspired to was not yet available
              locally, I saw entrepreneurship as the key to bringing that
              high-calibre work to Manitoba. Entrepreneurship is made for me
              because… there’s nothing else I can imagine doing that aligns so
              perfectly with my passions and skills. This journey has allowed me
              to channel my creativity, leadership, and vision into building
              something that not only fulfills me, but also makes a tangible
              impact on my community. Being an entrepreneur gives me the freedom
              to innovate, experiment with bold ideas, and see them come to life
              on screen. The impact I hope to make through my work is… to
              contribute to the growth and evolution of the creative and arts
              sector in Manitoba. I aim to create sustainable jobs and
              opportunities, ensuring that local talent can thrive without
              needing to leave Manitoba to pursue their dreams. By developing
              and producing high-quality films and shows, I want to showcase the
              unique stories, landscapes, and talents that our region has to
              offer. One of the most important lessons I’ve learned on my
              entrepreneurial journey is… that I am not always right, and that
              true success comes from surrounding myself with people who have
              different skill sets and perspectives than I do. I’ve come to
              understand the importance of diversity — not just in terms of
              skills and experience, but also in education and cultural
              background. This is crucial in bringing new ideas, creative
              solutions, and unique viewpoints to the table, and achieving
              results that I could never accomplish alone. My proudest
              accomplishment is… the incredible team and culture I’ve built.
              I’ve had the privilege of training, inspiring, and helping many
              individuals break into the industry here in Manitoba. This
              determination to build something from the ground up — not just for
              myself, but for others in my community — is something I am
              incredibly proud of. However, above all, I am most proud of my
              family — my three children and the life I’ve been able to build
              with my husband, Callum. Balancing the demands of a growing
              business with the responsibilities of raising a family has been
              challenging, but it has also been deeply rewarding. The biggest
              risk I took that paid off was… deciding to stay in Manitoba and
              build a film and television production company in a place where,
              almost 15 years ago, it seemed nearly impossible. Through
              persistence, innovation, and the unwavering belief that Manitoba
              had untapped potential, I’ve managed to create a successful and
              thriving business. I am proud to be a successful female business
              owner from the small town of Fort Whyte, Manitoba. My biggest
              setback has been… the loss of my mom to cancer at the age of 65.
              She was a tremendous support in every aspect of my life — whether
              it was as a business owner, a mother, or a wife. Her presence was
              a constant source of comfort and strength, and her absence has
              left an immeasurable void. Losing her has been devastating, and
              not a day goes by that I don’t think about her. However, I
              understand that loss is a part of life, and navigating through it
              is a journey that everyone must face, especially as a person, a
              mom, a wife, and an entrepreneur. Though this experience has set
              me back emotionally, it has also reminded me of the resilience and
              strength that my mom instilled in me. I overcame it by… I don’t
              think I’ll ever fully overcome the loss of my mom; it’s a profound
              change that has reshaped my life in ways I never expected. Rather
              than trying to move past the sadness, I’ve chosen to channel it
              into a source of strength and determination. In the wake of her
              passing, I’ve made it my mission to make each day count, push
              myself harder, and strive for even greater heights in my personal
              and professional life. Each day, I try to live up to the values
              she instilled in me, turning my grief into a powerful motivation
              to do better, not just for myself, but for my family, my business,
              and the community she so deeply believed in. The best advice I’ve
              received as an entrepreneur was… from Jim Treliving, who said,
              “Meg, you’re always working so hard; just make sure you take care
              of yourself first so you can continue to work as hard as you do.”
              No matter how much I dedicate myself to my work, I’ve learned that
              I can’t pour from an empty cup. I make it a priority to have the
              energy not just for my business, but for my family and myself.
              This balance has been crucial in sustaining the energy and passion
              I bring to my business every day. I surprise people when I tell
              them… I’m from a small farming town in rural Manitoba. People
              don’t expect someone from such a humble background to be so deeply
              involved in the entertainment industry. It’s a reminder that no
              matter where you come from, with hard work and determination, you
              can make your mark in any industry.
            </p>
          </div>
        </div>
        
      </div>
      <ExploreMore/>
    </>
  );
};
